import { Form, Grid, TextField, TextFieldProps } from '@approvalmax/ui/src/components';
import { JSXElementConstructor } from 'react';
import styled, { css } from 'styled-components';

const borderStyles = css`
    &:hover,
    &:focus-within {
        z-index: 1;
    }
`;

export const Wrapper = styled(Grid)`
    > :not(:first-of-type) {
        position: relative;
        left: -1px;
        width: calc(100% + 1px);
    }
`;

export const CountryTextField = styled<JSXElementConstructor<TextFieldProps>>((props) => (
    <Form.Part>
        <TextField {...props} />
    </Form.Part>
))`
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;

    ${borderStyles}
`;

export const AreaTextField = styled<JSXElementConstructor<TextFieldProps>>((props) => (
    <Form.Part>
        <TextField {...props} />
    </Form.Part>
))`
    border-radius: 0;
    border-left-width: 0;

    ${borderStyles}
`;

export const NumberTextField = styled<JSXElementConstructor<TextFieldProps>>((props) => (
    <Form.Part>
        <TextField {...props} />
    </Form.Part>
))`
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left-width: 0;

    ${borderStyles}
`;
